// Getters
export const adsBanner = (state) => {
  return state.adsBanner.data || []
}
export const adsBannerLoading = (state) => {
  return state.adsBanner.loading
}
export const adsBannerLastUpdate = (state) => {
  return state.adsBanner.lastUpdate
}

export const aawzFeed = (state) => {
  return state.aawzFeed.data || []
}
export const aawzFeedLoading = (state) => {
  return state.aawzFeed.loading
}
export const aawzFeedLastUpdate = (state) => {
  return state.aawzFeed.lastUpdate
}

export const externalLinks = (state) => {
  return state.externalLinks.data || []
}
export const externalLinksLoading = (state) => {
  return state.externalLinks.loading
}
export const externalLinksLastUpdate = (state) => {
  return state.externalLinks.lastUpdate
}

